import {fetch} from "../../utils/dataAccess";
import {SubmissionError} from "redux-form";

export function changePassword(values) {
    return dispatch => {
        dispatch(success(false))
        dispatch(error(null));
        dispatch(loading(true));
        return fetch('/change-password', { method: 'POST', data: values })
            .then(response => {
                dispatch(loading(false));
                dispatch(success(response.status === 204));
            })
            .catch(e => {
                dispatch(loading(false));
                if (e instanceof SubmissionError) {
                    dispatch(error(e.errors._error));
                    throw e;
                }

                dispatch(error(e.message));
            });
    };
}

export function error(error) {
    return { type: 'CHANGE_PASSWORD_ERROR', error };
}

export function loading(loading) {
    return { type: 'CHANGE_PASSWORD_LOADING', loading };
}

export function success(changed) {
    return { type: 'CHANGE_PASSWORD_SUCCESS', changed };
}

export function reset() {
    return dispatch => {
        dispatch(loading(false));
        dispatch(error(null));
    };
}
